import { UnusedSkipTokenOptions } from "@tanstack/react-query";
import { QueryKeyParams, TalaeraQueryKey } from ".";

export type BaseApiQueryOptions<
  TResponse,
  TParams extends QueryKeyParams,
  TPayload,
  TData,
> = Omit<
  UnusedSkipTokenOptions<
    TResponse,
    QueryError,
    TData,
    TalaeraQueryKey<TParams, TPayload>
  >,
  "queryFn" | "queryKey"
>;

export class QueryError extends Error {
  fetchError: unknown;

  constructor(error: unknown) {
    super(`Query function returned error: ${error}`);
    this.fetchError = error;
  }

  get isAbortError() {
    return (
      this.fetchError instanceof DOMException && this.fetchError.name === "AbortError"
    );
  }
}

export function wrapInQueryError<T>(promise: Promise<T>): Promise<T> {
  return promise.catch(error => {
    throw new QueryError(error);
  });
}
